import { Nullable } from '@/shared/types/app.types'

export interface CustomConfigurationFormState {
    receiverPersonnelList: Nullable<any[]>,
    daysToTargetDateList: Nullable<string[]>,
    daysToDelay: Nullable<number>,
    shouldNotifyPhysicianPetitioner: Nullable<boolean>,
    shouldNotifyPhysicianDepartment: Nullable<boolean>
}

export interface CustomConfigurationModal {
    customConfiguration: CustomConfigurationFormState
}
export const initialCustomConfigurationFormState =
    (): CustomConfigurationModal => ({
        customConfiguration: {
            daysToTargetDateList: null,
            daysToDelay: null,
            receiverPersonnelList: null,
            shouldNotifyPhysicianDepartment: null,
            shouldNotifyPhysicianPetitioner: null
        }
    })
